import React, { useState } from 'react';
import { ChevronDownIcon, ArrowRightIcon } from 'lucide-react';
export function HomeTopFAQs() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: "If your system is so good, why don't you just use it to build your own massive sales team?",
    answer: <>
          <p className="mb-3" data-id="element-468">
            We did. For nearly 20 years. We used this exact approach to recruit
            over 4,000 reps and generate $150M+ in revenue for our own
            organizations ($130M of that in Solar alone).
          </p>
          <p className="mb-3" data-id="element-469">
            So why sell it? We realized that in D2D, the biggest bottleneck is
            trying to wear every hat at once—Knocking, Managing, Training, and
            Recruiting. Even though we were successful, doing "everything" kept
            us from fully unleashing the one thing we loved most: The People
            Side.
          </p>
          <p className="mb-3" data-id="element-470">
            Our true passion is the recruiting journey—giving a rookie a shot,
            watching them succeed, and empowering leaders to build their dream
            teams. We decided to stop being "Generalist Operators" and become
            Specialized Partners. We build the world-class engine so you can
            focus on driving the car.
          </p>
        </>
  }, {
    question: 'How are you different from a recruiter?',
    answer: <>
          <p className="mb-3" data-id="element-471">
            Traditional recruiters focus on filling seats. We help you build a
            structured recruiting, training, and early-retention system that
            keeps producing long after the initial launch. Instead of just
            sending resumes, we support:
          </p>
          <ul className="space-y-2 mb-3 ml-4" data-id="element-472">
            <li data-id="element-473">
              <strong data-id="element-474">Messaging and Positioning:</strong> How you present the
              opportunity.
            </li>
            <li data-id="element-475">
              <strong data-id="element-476">Applicant Generation:</strong> Sourcing the right people.
            </li>
            <li data-id="element-477">
              <strong data-id="element-478">Screening and Qualification:</strong> Filtering out the
              noise.
            </li>
            <li data-id="element-479">
              <strong data-id="element-480">Training & Sales School:</strong> Providing the initial
              kick-start to get them field-ready.
            </li>
            <li data-id="element-481">
              <strong data-id="element-482">Onboarding & Early-Retention:</strong> Systems to keep
              them past the first 60 days.
            </li>
            <li data-id="element-483">
              <strong data-id="element-484">Optimization:</strong> Ongoing refinement based on data.
            </li>
          </ul>
          <p data-id="element-485">
            The goal isn't just "more interviews"—it's a predictable system you
            can rely on month after month.
          </p>
        </>
  }, {
    question: 'How fast will we see results?',
    answer: <>
          <p className="mb-3" data-id="element-486">
            Most companies begin hiring within 3–5 days of launch. Depending on
            your team size and market, you can expect:
          </p>
          <ul className="space-y-2 ml-4" data-id="element-487">
            <li data-id="element-488">
              <strong data-id="element-489">Month 1:</strong> 10–20 new reps.
            </li>
            <li data-id="element-490">
              <strong data-id="element-491">Days 30–60:</strong> Higher rookie stick rates and
              consistent applicant flow.
            </li>
            <li data-id="element-492">
              <strong data-id="element-493">Days 60–90:</strong> A fully dialed-in system (your team +
              our framework working seamlessly).
            </li>
            <li data-id="element-494">
              <strong data-id="element-495">Month 4–5:</strong> Most partners see the system become
              self-funding.
            </li>
          </ul>
        </>
  }, {
    question: 'Do you only work with D2D companies?',
    answer: <>
          <p className="mb-3" data-id="element-496">Yes. We specialize in three specific models:</p>
          <ul className="space-y-2 mb-3 ml-4" data-id="element-497">
            <li data-id="element-498">Door-to-door organizations.</li>
            <li data-id="element-499">Direct sales companies (in-home closing).</li>
            <li data-id="element-500">Field-based home services sales teams.</li>
          </ul>
          <p data-id="element-501">
            This includes Solar, Roofing, Pest, Windows, Telecom, HVAC, Energy,
            Life Insurance, Community Solar, and similar models. Our system is
            built specifically for the unique demands of field
            sales—seasonality, churn patterns, territory structure, and
            aggressive ramp-up cycles.
          </p>
        </>
  }, {
    question: 'What kind of commitment is required?',
    answer: 'We launch with a 90-day commitment. This ensures the recruiting system is installed correctly, your team is aligned, and the early retention systems are fully operational. After that, our service moves to month-to-month, as long as the partnership makes sense for both sides.'
  }, {
    question: 'Do you offer any guarantees?',
    answer: <>
          <p className="mb-3" data-id="element-502">
            Yes. We offer two specific guarantees to protect your investment:
          </p>
          <ul className="space-y-2 ml-4" data-id="element-503">
            <li data-id="element-504">
              <strong data-id="element-505">30-Day Money Back Guarantee:</strong> If you feel the
              system isn't moving in the right direction within the first 30
              days, you may request a full refund.
            </li>
            <li data-id="element-506">
              <strong data-id="element-507">90-Day Performance Guarantee:</strong> If the system is
              not performing in line with the agreed-upon baseline metrics by
              day 90, we continue working for free until it does.
            </li>
          </ul>
        </>
  }, {
    question: 'What kind of involvement is required from our leadership team?',
    answer: <>
          <p className="mb-3" data-id="element-508">
            We handle the majority of the operational and strategic workload,
            but your leadership plays a critical role in:
          </p>
          <ul className="space-y-2 mb-3 ml-4" data-id="element-509">
            <li data-id="element-510">Setting expectations.</li>
            <li data-id="element-511">Providing clear role standards.</li>
            <li data-id="element-512">Supporting new hires in their first weeks.</li>
            <li data-id="element-513">Giving feedback on candidate quality and fit.</li>
          </ul>
          <p data-id="element-514">
            The system dramatically reduces your recruiting burden, but it still
            relies on partnership and communication.
          </p>
        </>
  }, {
    question: 'Will this work in a competitive or saturated market?',
    answer: <>
          <p className="mb-3" data-id="element-515">
            Yes. Most of our partners operate in competitive regions. The system
            adapts through:
          </p>
          <ul className="space-y-2 mb-3 ml-4" data-id="element-516">
            <li data-id="element-517">Market-specific positioning.</li>
            <li data-id="element-518">Targeted messaging.</li>
            <li data-id="element-519">Screening for alignment.</li>
            <li data-id="element-520">Continuous optimization based on data.</li>
          </ul>
          <p data-id="element-521">
            Market competitiveness influences pace and cost, but structure
            always outperforms randomness.
          </p>
        </>
  }, {
    question: 'What if we already have internal recruiters?',
    answer: <>
          <p className="mb-3" data-id="element-522">
            That is often a benefit. Many partners keep their internal
            recruiters and plug them into the HIRE system. We can:
          </p>
          <ul className="space-y-2 mb-3 ml-4" data-id="element-523">
            <li data-id="element-524">Support them.</li>
            <li data-id="element-525">Train them.</li>
            <li data-id="element-526">Provide structure.</li>
            <li data-id="element-527">Improve consistency.</li>
          </ul>
          <p data-id="element-528">
            We're not replacing people—we're upgrading the system they operate
            within to make their output more predictable.
          </p>
        </>
  }];
  return <section className="section-padding bg-gray-50" data-id="element-529">
      <div className="container-custom" data-id="element-530">
        <div className="max-w-3xl mx-auto" data-id="element-531">
          <div className="text-center mb-8 md:mb-10 lg:mb-12" data-id="element-532">
            <h2 className="mb-3 md:mb-4 lg:mb-6" data-id="element-533">Frequently Asked Questions</h2>
          </div>

          <div className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-534">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded border-2 border-gray-200 overflow-hidden shadow-md" data-id="element-535">
                <button className="w-full px-4 md:px-5 lg:px-6 py-3 md:py-4 lg:py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-536">
                  <h4 className="font-semibold pr-6 md:pr-8" data-id="element-537">{faq.question}</h4>
                  <ChevronDownIcon className={`h-5 w-5 md:h-6 md:w-6 text-amber flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-538" />
                </button>
                {openIndex === index && <div className="px-4 md:px-5 lg:px-6 pb-3 md:pb-4 lg:pb-5 bg-gray-50" data-id="element-539">
                    <div className="leading-relaxed text-sm md:text-base" data-id="element-540">
                      {typeof faq.answer === 'string' ? <p data-id="element-541">{faq.answer}</p> : faq.answer}
                    </div>
                  </div>}
              </div>)}
          </div>

          <div className="text-center" data-id="element-542">
            <a href="/book-call" className="inline-flex items-center bg-amber hover:bg-amber-dark text-navy font-bold px-6 md:px-8 py-3 md:py-4 rounded transition-colors shadow-lg text-sm md:text-base" data-id="element-543">
              Book Your Strategy Call{' '}
              <ArrowRightIcon className="ml-2 h-4 w-4 md:h-5 md:w-5" data-id="element-544" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}